import store from "../store/store";
const appcuesEnabled = process.env.REACT_APP_APPCUES_ENABLED === "true";
const themeSettingEnabled = process.env.REACT_APP_THEME_SETTING_ENABLED === "true";
const hubspotTrackingCode = process.env.REACT_APP_HUBSPOT_TRACKING_CODE;

export default class SystemHelper {

    static SETTINGS = {
        "CUSTOM_FIELDS_ENABLED": "CUSTOM_FIELDS_ENABLED",
        "ASSETS_ENABLED": "ASSETS_ENABLED",
        "FORECASTS_ENABLED": "FORECASTS_ENABLED",
    }
    static getSettingValue = (key) => {
        const storeState = store.getState();
        if (storeState.contract && storeState.contract.contract && storeState.contract.contractid) {
            return storeState.contract.contract.settings[key];
        }
        else if (storeState.auth && storeState.auth.userProfile && storeState.auth.userProfile.accountid) {
            return storeState.auth.userProfile.settings[key];
        }
        else {
            return null;
        }
    }
    static getSettingValueBoolean = (key) => {
        const storeState = store.getState();
        if (storeState.contract && storeState.contract.contract && storeState.contract.contractid) {
            return storeState.contract.contract.settings[key] === 'TRUE';
        }
        else if (storeState.auth && storeState.auth.userProfile && storeState.auth.userProfile.accountid) {
            return storeState.auth.userProfile.settings[key] === 'TRUE';
        }
        else {
            return false;
        }
    }
    static updateExternalTrackerLibraries = () => {
        if (appcuesEnabled && window.Appcues) {
            SystemHelper.appcuesUpdateUserInfo();
        }
        if (hubspotTrackingCode && window._hsq) {
            SystemHelper.hubspotUpdateUserInfo();
        }
    }
    static appcuesUpdateUserInfo = () => {
        if (appcuesEnabled && window.Appcues) {
            const storeState = store.getState();
            if (storeState.auth && storeState.auth.userProfile) {
                let powerbienabled = process.env.REACT_APP_POWERBI_ENABLED === "true" && (storeState.auth.userProfile.allowpowerbimenus || ['System Owner', 'System Administrator'].includes(storeState.auth.userProfile.accounttype));
                const props = {
                    userCreatedAt: storeState.auth.userProfile.createdate ? Math.floor(new Date(storeState.auth.userProfile.createdate).getTime() / 1000) : null,
                    userCompanyName: storeState.auth.userProfile.company,
                    accountId: storeState.auth.userProfile.accountid,
                    userFullName: storeState.auth.userProfile.name,
                    userAccountType: storeState.auth.userProfile.accounttype,
                    instanceCode: process.env.REACT_APP_PRODUCT_KEY,
                    urlDomain: process.env.PUBLIC_URL,
                    userEmail: storeState.auth.userProfile.email,
                    telephone: storeState.auth.userProfile.telephone,
                    jobtitle: storeState.auth.userProfile.jobtitle,
                    powerbienabled
                }
                if (storeState.contract && storeState.contract.contract && storeState.contract.contractid && storeState.contract.user) {
                    props.contractUserRole = storeState.contract.user.rolepermissions;
                    props.contractUserPartyType = storeState.contract.user.party;
                    props.contractStartDate = storeState.contract.contract.startdate ? Math.floor(new Date(storeState.contract.contract.startdate).getTime() / 1000) : null;
                    props.contractCurrentEndDate = storeState.contract.contract.completiondate ? Math.floor(new Date(storeState.contract.contract.completiondate).getTime() / 1000) : null;
                    props.contractType = storeState.contract.contract.contracttype;
                }

                window.Appcues.identify(storeState.auth.userProfile.userguid, props);
                window.Appcues.loadLaunchpad("#bi-fd-launchpad", {
                    //Optionally specify the position of the content relative to the Launchpad icon. Possible values are as followed: 
                    //	- center (default value, i.e. bottom-center)
                    //	- left (i.e. bottom-left)
                    //	- right (i.e. bottom-right)
                    //	- top (i.e. top-center)
                    //	- top-left
                    //	- top-right
                    position: "bottom-left",
                    // Optionally add a header or footer. This must be HTML.
                    header: "<h1>Tutorials</h1>",
                    footer: "<p>Questions? Let us know support@builtintelligence.com</p>",
                    // And if you'd prefer to use a custom icon rather than the default "bell" icon, you can optionally pass 
                    // in an icon as well. Make sure that src is set to the right resource, whether it's in your site's directory or hosted
                    icon: "/media/icons/alert-svgrepo-com5.svg"
                });
            }
        }
    }
    static hubspotUpdateUserInfo = () => {
        if (hubspotTrackingCode && window._hsq) {
            const storeState = store.getState();
            if (storeState.auth && storeState.auth.userProfile) {
                var _hsq = (window._hsq = window._hsq || []);
                _hsq.push([
                    "identify",
                    {
                        email: storeState.auth.userProfile.email,
                        firstname: storeState.auth.userProfile.name,
                        lastname: "",
                    },
                ]);
            }
        }
    }
    static hubspotUpdateEvent = (eventName) => {
        if (hubspotTrackingCode && window._hsq) {
            var _hsq = (window._hsq = window._hsq || []);
            _hsq.push([
                "trackCustomBehavioralEvent",
                // {
                //     name: "FD_CLICK_" + eventName.toUpperCase(),
                // },
                {
                    name: `pe${hubspotTrackingCode}_fd_click_${eventName.toLowerCase()}`,
                },
            ]);

        }
    }
    static delightedScript = () => {
        const storeState = store.getState();
        if (storeState.auth && storeState.auth.userProfile) {
            const delightedScript = document.createElement("script");
            delightedScript.innerHTML = `
            !function(e,t,r,n){
                if(!e[n]){
                for(var a=e[n]=[],i=["survey","reset","config","init","set","get","event","identify","track","page","screen","group","alias"],s=0;s<i.length;s++){
                    var c=i[s];
                    a[c]=a[c]||function(e){
                    return function(){
                        var t=Array.prototype.slice.call(arguments);
                        a.push([e,t]);
                    };
                    }(c);
                }
                a.SNIPPET_VERSION="1.0.1";
                var o=t.createElement("script");
                o.type="text/javascript";
                o.async=!0;
                o.src="https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/"+r+"/"+n+".js";
                var p=t.getElementsByTagName("script")[0];
                p.parentNode.insertBefore(o,p);
                }
            }(window,document,"BxFxoYI7ywNEqzGO","delightedNps");

            delightedNps.survey({
                email: "${storeState.auth.userProfile.email}",
                name: "${storeState.auth.userProfile.name}",
                createdAt: "${storeState.auth.userProfile.createdate}",
                properties: {
                company: "${storeState.auth.userProfile.company}",
                productKey: "${process.env.REACT_APP_PRODUCT_KEY}"
                }
            });
            `;

            document.head.appendChild(delightedScript);
        }
    }
    static hexToRgbComponents(hex) {
        // 1. Remove the '#' if present
        const cleanHex = hex.replace(/^#/, '');

        // 2. Parse the three pairs of hex digits
        const r = parseInt(cleanHex.substring(0, 2), 16); // Red component (first 2 digits)
        const g = parseInt(cleanHex.substring(2, 4), 16); // Green component (middle 2 digits)
        const b = parseInt(cleanHex.substring(4, 6), 16); // Blue component (last 2 digits)

        // 3. Return as a comma-separated string
        return `${r}, ${g}, ${b}`;
    }

    // static setUITheme = () => {
    //     const storeState = store.getState();
    //     if (storeState.auth && storeState.auth.userProfile) {
    //         var theme = JSON.parse(storeState.auth.userProfile?.companycustomthemejson);
    //         const root = document.documentElement; // The :root element (<html>)

    //         root.style.setProperty('--theme-topandleft-menu-colour', theme.attributes.topAndLeftMenuColour);
    //         root.style.setProperty('--theme-font', theme.attributes.font);
    //         root.style.setProperty('--theme-font-size', theme.attributes.fontSize);
    //         //root.style.setProperty('--theme-aside-menu-link-text-font-weight', theme.attributes.asideMenuLinkTextFontWeight);
    //         root.style.setProperty('--theme-left-menu-font-colour', theme.attributes.leftMenuFontColour);
    //         root.style.setProperty('--theme-left-menu-font-colour-openhereactivehover', theme.attributes.leftMenuFontColourOpenHereActiveHover);
    //         root.style.setProperty('--theme-foreground-page-colour', theme.attributes.foregroundPageColour);
    //         root.style.setProperty('--theme-background-page-colour', theme.attributes.backgroundPageColour);
    //         root.style.setProperty('--theme-header-font-colour', theme.attributes.headerFontColour);
    //         root.style.setProperty('--theme-body-font-colour', theme.attributes.bodyFontColour);
    //         //root.style.setProperty('--theme-body-button-font-colour', theme.attributes.bodyButtonFontColour);
    //         root.style.setProperty('--theme-topleftcreatenew-button-font-colour', theme.attributes.topLeftCreateNewButtonColour);
    //         //since i need to apply opacity for the background color, i needed to get the rgb format
    //         root.style.setProperty('--theme-topleftcreatenew-button-rgb', this.hexToRgbComponents(theme.attributes.topLeftCreateNewButtonColour));
    //         root.style.setProperty('--theme-communicate-button-font-colour', theme.attributes.communicateButtonColour);
    //         root.style.setProperty('--theme-primary-icon-colour', theme.attributes.primaryIconColour);
    //         root.style.setProperty('--theme-secondary-icon-colour', theme.attributes.secondaryIconColour);
    //         root.style.setProperty('--theme-red-colour-code-rag-status', theme.attributes.dangerColourCodeForRAGStatus);
    //         root.style.setProperty('--theme-amber-colour-code-rag-status', theme.attributes.warningColourCodeForRAGStatus);
    //         root.style.setProperty('--theme-green-colour-code-rag-status', theme.attributes.successColourCodeForRAGStatus);
    //     }
    // }

    static setUITheme = (rawTheme) => {
        if (rawTheme) {
            var theme = JSON.parse(rawTheme);
            const root = document.documentElement; // The :root element (<html>)

            root.style.setProperty('--theme-topandleft-menu-colour', theme.attributes.topAndLeftMenuColour);
            root.style.setProperty('--theme-primary-font', theme.attributes.primaryFont);
            root.style.setProperty('--theme-secondary-font', theme.attributes.secondaryFont);
            root.style.setProperty('--theme-font-size', theme.attributes.fontSize);
            //root.style.setProperty('--theme-aside-menu-link-text-font-weight', theme.attributes.asideMenuLinkTextFontWeight);
            root.style.setProperty('--theme-left-menu-font-colour', theme.attributes.leftMenuFontColour);
            root.style.setProperty('--theme-left-menu-font-colour-openhereactivehover', theme.attributes.leftMenuFontColourOpenHereActiveHover);
            root.style.setProperty('--theme-foreground-page-colour', theme.attributes.foregroundPageColour);
            root.style.setProperty('--theme-background-page-colour', theme.attributes.backgroundPageColour);
            root.style.setProperty('--theme-header-font-colour', theme.attributes.headerFontColour);
            root.style.setProperty('--theme-body-font-colour', theme.attributes.bodyFontColour);
            //root.style.setProperty('--theme-body-button-font-colour', theme.attributes.bodyButtonFontColour);
            root.style.setProperty('--theme-topleftcreatenew-button-font-colour', theme.attributes.topLeftCreateNewButtonColour);
            //since i need to apply opacity for the background color, i needed to get the rgb format
            root.style.setProperty('--theme-topleftcreatenew-button-rgb', this.hexToRgbComponents(theme.attributes.topLeftCreateNewButtonColour));
            root.style.setProperty('--theme-communicate-button-font-colour', theme.attributes.communicateButtonColour);
            root.style.setProperty('--theme-primary-icon-colour', theme.attributes.primaryIconColour);
            root.style.setProperty('--theme-secondary-icon-colour', theme.attributes.secondaryIconColour);
            root.style.setProperty('--theme-red-colour-code-rag-status', theme.attributes.dangerColourCodeForRAGStatus);
            root.style.setProperty('--theme-amber-colour-code-rag-status', theme.attributes.warningColourCodeForRAGStatus);
            root.style.setProperty('--theme-green-colour-code-rag-status', theme.attributes.successColourCodeForRAGStatus);
        } else {
            this.setDefaultUITheme();
        }
    }

    static setDefaultUITheme = () => {
        const root = document.documentElement;

        root.style.setProperty('--theme-topandleft-menu-colour', "#1e1e2d");
        root.style.setProperty('--theme-primary-font', "Roboto, Helvetica, sans-serif");
        root.style.setProperty('--theme-secondary-font', "Helvetica Neue, Segoe UI, helvetica, verdana, sans-serif");
        root.style.setProperty('--theme-font-size', "1.1rem");
        //root.style.setProperty('--theme-aside-menu-link-text-font-weight', "400");
        root.style.setProperty('--theme-left-menu-font-colour', "#cccccc");
        root.style.setProperty('--theme-left-menu-font-colour-openhereactivehover', "#ffffff");
        root.style.setProperty('--theme-foreground-page-colour', "#333");
        root.style.setProperty('--theme-background-page-colour', "#ffffff");
        root.style.setProperty('--theme-header-font-colour', "#333");
        root.style.setProperty('--theme-body-font-colour', "#333");
        //root.style.setProperty('--theme-body-button-font-colour', "#2d6da3");
        root.style.setProperty('--theme-topleftcreatenew-button-font-colour', "#07B388");
        root.style.setProperty('--theme-topleftcreatenew-button-rgb', '7, 179, 136');
        root.style.setProperty('--theme-communicate-button-font-colour', "#5cb85c");
        root.style.setProperty('--theme-primary-icon-colour', "#494b74");
        root.style.setProperty('--theme-secondary-icon-colour', "#494b74");
        root.style.setProperty('--theme-red-colour-code-rag-status', "#D3438E");
        root.style.setProperty('--theme-amber-colour-code-rag-status', "#E98E23");
        root.style.setProperty('--theme-green-colour-code-rag-status', "#07B388");
    }

    static getThemeTextFont = () => {
        const storeState = store.getState();
        if (themeSettingEnabled && storeState.auth?.userProfile?.companycustomthemejson) {
            var theme = JSON.parse(storeState.auth.userProfile.companycustomthemejson);

            return theme?.attributes?.asideMenuLinkTextFont;
        } else {
            return 'Poppins, Helvetica, sans-serif';
        }
    }
}